import { EventEmitter, Injectable } from '@angular/core';
import { StorageService } from './storage.service';
import { Theme } from '@shared/models/theme.model';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ThemeService {
  document: Document;
  currentTheme: Theme;
  themeKeyName = 'clappit-current-theme';

  themeNameChange: EventEmitter<Theme> = new EventEmitter<Theme>();

  constructor(private storageService: StorageService) {}

  initializeThemeDocument(doc: Document) {
    if (!this.document) this.document = doc;
    const curThem = this.storageService.getItem(this.themeKeyName);
    console.log('theme name got from session ', curThem);
    if (curThem) {
      this.currentTheme = curThem as Theme;
      this.switchTheme(this.currentTheme);
    } else {
      this.switchTheme('dark-theme');
    }
  }
  // Swap them out, and keep track of the new theme
  switchTheme(newTheme: Theme): void {
    if (this.document.body.classList.contains(this.currentTheme)) {
      console.log('this.currentTheme found', this.currentTheme);
      this.document.body.classList.replace(this.currentTheme, newTheme);
    } else {
      console.log('this.currentTheme not found adding ', newTheme);
      this.document.body.classList.add(newTheme);
    }
    this.storageService.removeItem(this.themeKeyName);
    this.currentTheme = newTheme;
    this.storageService.setItem(this.themeKeyName, newTheme);

    this.themeNameChange.emit(newTheme);

    console.log('Current theme ', this.currentTheme);
  }
}
